import { render } from "./ThisWeekTabCont.vue?vue&type=template&id=ecfe97ec"
import script from "./ThisWeekTabCont.vue?vue&type=script&lang=js"
export * from "./ThisWeekTabCont.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__